import { useContext } from "react";
import { DashboardContext, DashboardContextType } from "../contexts/dashboard";

export function useDashboard(): DashboardContextType {
    const context = useContext(DashboardContext);
    if (!context) {
        throw new Error('useDashboard deve ser usado dentro de um DashboardProvider');
    }
    return context;
}